<flx-modal
  [dismissible]="!isLoading()"
  [class.large]="isLarge()"
  (dismiss)="manualMergeCompleted.emit(null)"
  class="flx-ds"
>
  @if (headerTitle() && !isLoading()) {
    <div
      class="flx-modal-title"
      flxModalHeaderTitle
    >
      <h1 data-testId="merge-conflict-header">
        {{ this.headerTitle() }}
      </h1>
    </div>
  }

  @if (headerSubtitle() && !isLoading()) {
    <div
      class="flx-modal-subtitle"
      flxModalHeaderSubtitle
    >
      {{ headerSubtitle() }}
    </div>
  }

  @if (isLoading()) {
    <div class="flex h-full w-full items-center justify-center bg-white bg-opacity-80">
      <flx-spinner
        [text]="spinnerText()"
        size="small"
      />
    </div>
  }

  <div [ngClass]="isLoading() ? 'hidden' : 'contents'">
    <router-outlet name="mergeConflicts" />
  </div>
</flx-modal>
